import { render } from "./SearchPersonItem.vue?vue&type=template&id=affc71e8"
import script from "./SearchPersonItem.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./SearchPersonItem.vue?vue&type=script&charset=utf-8&lang=js"

import "./SearchPersonItem.vue?vue&type=style&index=0&id=affc71e8&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__